export default {
  install(app) {
    app.directive('onlyNumber', {
      beforeMount(el) {
        el.addEventListener('keypress', (event) => {
          const keyCode = event.which;
          if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
            // 46 is dot
            event.preventDefault();
          }
        });
      },
    });

    app.directive('onlyInteger', {
      beforeMount(el) {
        el.addEventListener('keypress', (event) => {
          const keyCode = event.which;
          if (keyCode < 48 || keyCode > 57) {
            event.preventDefault();
          }
        });
      },
    });

    app.directive('oneDecimal', {
      beforeMount(el) {
        el.addEventListener('keypress', (event) => {
          const keyCode = event.keyCode ? event.keyCode : event.which;
          const value = event.target.value;
          const i = value.indexOf('.');
          if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || i !== -1)) {
            // 46 is dot
            event.preventDefault();
          } else if (
            event.target.selectionStart === event.target.selectionEnd &&
            (i === -1 || event.target.selectionEnd > i) &&
            value.split('.')[1]?.length > 0
          ) {
            // restrict to 1 decimal place
            event.preventDefault();
          }
        });
      },
    });

    app.directive('twoDecimal', {
      beforeMount(el) {
        el.addEventListener('keypress', (event) => {
          const keyCode = event.keyCode ? event.keyCode : event.which;
          const value = event.target.value;
          const i = value.indexOf('.');
          if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || i !== -1)) {
            // 46 is dot
            event.preventDefault();
          } else if (
            event.target.selectionStart === event.target.selectionEnd &&
            (i === -1 || event.target.selectionEnd > i) &&
            value.split('.')[1]?.length > 1
          ) {
            // restrict to 1 decimal place
            event.preventDefault();
          }
        });
      },
    });
  },
};
